export const getAlertStreamFilterOptions = (ownerOptions = [], alertAgentOptions = []) => {
  return [
    {
      id: "alert_owner",
      name: "Alert Owner",
      options: ownerOptions,
      searchable: true,
      multiSelect: false,
      showInitials: true,
    },
    {
      id: "alert_agent",
      name: "Alert Agent",
      options: alertAgentOptions,
      searchable: true,
      multiSelect: false,
    },
    {
      id: "status",
      name: "Status",
      options: [
        { id: "Open", name: "Open" },
        { id: "Resolved", name: "Resolved" },
      ],
      multiSelect: false,
    },
    {
      id: "priority",
      name: "Priority",
      options: [
        { id: "High", name: "High" },
        { id: "Medium", name: "Medium" },
        { id: "Low", name: "Low" },
      ],
      multiSelect: false,
    },
  ];
};

export const priorityOptions = [
  { id: "High", name: "High" },
  { id: "Medium", name: "Medium" },
  { id: "Low", name: "Low" },
];

export const priorityOptionsForCard = [
  { label: "High", value: "High" },
  { label: "Medium", value: "Medium" },
  { label: "Low", value: "Low" },
];

export const statusOptionsForCard = [
  { label: "Open", value: "Open" },
  { label: "Resolved", value: "Resolved" },
];

export const alertAgentHeaders = [
  {
    label: "Alert Agent Name",
    key: "alert_agent_name",
    width: 3,
    sortable: true,
  },
  {
    label: "Status",
    key: "status",
    width: 2,
    sortable: true,
  },
  {
    label: "Object",
    key: "object",
    width: 2,
    sortable: true,
  },
  {
    label: "Created By",
    key: "created_by",
    width: 2,
    sortable: true,
  },
  {
    label: "Created On",
    key: "created_on",
    width: 2,
    sortable: true,
  },
  {
    label: "Next Run at",
    key: "next_run_at",
    width: 2,
    sortable: true,
  },
];

export const alertTabs = [
  { title: "Alert Agents" },
  { title: "Alert Stream" },
];
